import React, { Component } from 'react';
import './documentaion.css';
import {   headerGridData } from './header-data';
import * as _ from 'lodash';
import { CodeEditor } from '../../../../rc-core';

class Headers extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    ...headerGridData
  }

  componentWillMount() {
    this.getHeaders();
  }

  componentWillReceiveProps(nextProps) {
    const { label } = this.props.payload;
    if (nextProps.payload.label !== label) {
      //refresh data from store
      this.getHeaders(nextProps);
    }

  }

  onGridReady = (params) => {
    this.api = params.api;
    this.api.sizeColumnsToFit();
  }


  onRowSelected = (params) => {
    const { header, value } = params.data;

    if (params.node.lastChild) {

      params.api.updateRowData({
        add: [
          { check: "", header: "", value: "", description: "" },
        ]
      });

      return;
    }
  }

  onCellValueChanged = (params) => {
    const { header, value } = params.data;
    this.syncHeaders(params);
  }

  syncHeaders(params) {
    const headers = [];
    params.api.forEachNode(function (rowNode, index) {
      headers.push(rowNode.data);
    });

    this.props.setHeaders(headers);
  }

  getHeaders(nextProps) {
    const props = nextProps || this.props;
    let def = { check: "", header: "", value: "", description: "" };
    const headers = _.get(props.payload, 'request.headers') || [def];
    this.setState({ rowData: headers });
  }

  getValue(){
    const headers = _.get(this.props.payload, 'request.body');
    return headers;
  }

  render() {
    return (
      <div className="documentation-view">
          <CodeEditor
            mode={'json'}
            onChange={this.onChange}
            value={this.getValue()}
          />
      </div>
    );
  }
}

export default Headers;